import { DomainDetail } from "@dev/ee-api/ee-api-models";

export const isDomainVerified = (domain: DomainDetail): boolean => !!domain?.Spf;
